import {
  GET_OFFER_LIST_REQUEST,
  GET_OFFER_LIST_RESPONSE,
  ADD_OFFER_REQUEST,
  ADD_OFFER_RESPONSE,
  UPDATE_OFFER_BY_OFFER_ID_REQUEST,
  UPDATE_OFFER_BY_OFFER_ID_RESPONSE,
  DELETE_OFFER_BY_OFFER_ID_REQUEST,
  DELETE_OFFER_BY_OFFER_ID_RESPONSE,
  UPDATE_OFFER_STATUS_BY_OFFER_ID_REQUEST,
  UPDATE_OFFER_STATUS_BY_OFFER_ID_RESPONSE,
} from "./actionTypes";

export const getOfferListRequest = () => {
  return {
    type: GET_OFFER_LIST_REQUEST,
  };
};

export const getOfferListResponse = (apiResponse) => {
  return {
    type: GET_OFFER_LIST_RESPONSE,
    payload: { apiResponse },
  };
};

export const addOfferRequest = (data) => {
  return {
    type: ADD_OFFER_REQUEST,
    payload: { data },
  };
};

export const addOfferResponse = (apiResponse) => {
  return {
    type: ADD_OFFER_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateOfferByOfferIdRequest = (offerId, data) => {
  return {
    type: UPDATE_OFFER_BY_OFFER_ID_REQUEST,
    payload: { offerId, data },
  };
};

export const updateOfferByOfferIdResponse = (apiResponse) => {
  return {
    type: UPDATE_OFFER_BY_OFFER_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateOfferStatusByOfferIdRequest = (offerId, status) => {
  return {
    type: UPDATE_OFFER_STATUS_BY_OFFER_ID_REQUEST,
    payload: { offerId, status },
  };
};

export const updateOfferStatusByOfferIdResponse = (apiResponse) => {
  return {
    type: UPDATE_OFFER_STATUS_BY_OFFER_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const deleteOfferByOfferIdRequest = (offerId) => {
  return {
    type: DELETE_OFFER_BY_OFFER_ID_REQUEST,
    payload: { offerId },
  };
};

export const deleteOfferByOfferIdResponse = (apiResponse) => {
  return {
    type: DELETE_OFFER_BY_OFFER_ID_RESPONSE,
    payload: { apiResponse },
  };
};
